import {
  oneOf,
  selectedRowFilter,
  stringFilter,
} from '@/components/Internal/DataTable'

export type UserFilter = 'CUSTOMER' | 'OTHER'

export const userListFilters = {
  // Customers outnumber staff by far, so the list opens on them.
  group: oneOf<UserFilter>(['CUSTOMER', 'OTHER'], 'CUSTOMER'),
  // The whole list is already in memory, so the match runs here rather than
  // as a request the server would have to grow a parameter for.
  search: stringFilter(),
  /** Which account the pane beside the list is showing. */
  selected: selectedRowFilter(),
}
